[
  { "id": 1, "name": "Forward"},
  { "id": 2, "name": "Back"},
  { "id": 3, "name": "Goalkeeper"},
  { "id": 4, "name": "Central Midfield"},
  { "id": 5, "name": "Midfield"},
  { "id": 6, "name": "Left-Back"},
  { "id": 7, "name": "Midfielder"},
  { "id": 8, "name": "Defender"},
  { "id": 9, "name": "Centre-Back"},
  { "id": 10, "name": "Centre Forward"},
  { "id": 11, "name": "Right Winger"},
  { "id": 12, "name": "Left Winger"},
  { "id": 13, "name": "Defensive Midfield"},
  { "id": 14, "name": "Right-Back"},
  { "id": 15, "name": "Attacking Midfield"},
  { "id": 16, "name": "Attacking Central Midfield"}
]